(() => {
  const GLASS_VARIANT_ID = 46626618048643;
  const WEEKLY_SELLING_PLAN_ID = 1263435907;

  // ✅ only run on these two product pages
  const ALLOWED_HANDLES = new Set([
    "chefs-choice-standard-gf-df-new-copy",
    "family-meal-plan",
  ]);

  const GLASS_MATCH = "glass";

  function shouldRunOnThisProductPage() {
    const parts = window.location.pathname.split("/").filter(Boolean);
    const handle = parts[0] === "products" ? parts[1] : null;
    return !!handle && ALLOWED_HANDLES.has(handle);
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }

  async function addGlassSubscription() {
    const cart = await getCart();
    const already = cart.items.some(i => i.variant_id === GLASS_VARIANT_ID);
    if (already) return;

    const item = {
      id: GLASS_VARIANT_ID,
      quantity: 1,
      selling_plan: WEEKLY_SELLING_PLAN_ID,
      properties: { "Added via": "Chef's Choice Container Option" }
    };

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [item] })
    });

    if (!res.ok) throw new Error("Failed to add glass subscription add-on");
  }

  async function removeGlassSubscription() {
    const cart = await getCart();
    const glassLine = cart.items.find(i => i.variant_id === GLASS_VARIANT_ID);
    if (!glassLine) return;

    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: glassLine.key, quantity: 0 })
    });

    if (!res.ok) throw new Error("Failed to remove glass add-on");
  }

  function isGlassSelected() {
    const selects = Array.from(document.querySelectorAll("select"));
    for (const s of selects) {
      const context =
        ((s.name || "") + " " + (s.id || "") + " " + (s.closest("div")?.innerText || ""))
          .toLowerCase();

      if (context.includes("container") || context.includes("glass")) {
        const val = (s.value || "").toLowerCase();
        if (val.includes(GLASS_MATCH)) return true;
      }
    }

    const radios = Array.from(document.querySelectorAll('input[type="radio"]'));
    for (const r of radios) {
      if (!r.checked) continue;
      const v = (r.value || "").toLowerCase();
      const label = (r.closest("label")?.innerText || "").toLowerCase();
      if (v.includes(GLASS_MATCH) || label.includes(GLASS_MATCH)) return true;
    }

    return false;
  }

  async function syncGlassAddonToSelection() {
    if (!shouldRunOnThisProductPage()) return;

    const glass = isGlassSelected();
    if (glass) await addGlassSubscription();
    else await removeGlassSubscription();
  }

  function bind() {
    if (!shouldRunOnThisProductPage()) return;

    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    form.addEventListener("submit", () => {
      setTimeout(() => syncGlassAddonToSelection().catch(console.error), 900);
    });

    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;
      const name = (t.getAttribute("name") || "").toLowerCase();
      const id = (t.getAttribute("id") || "").toLowerCase();
      if (name.includes("container") || name.includes("glass") || id.includes("container") || id.includes("glass")) {
        setTimeout(() => syncGlassAddonToSelection().catch(console.error), 150);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", bind);
})();